var styleDataHash = "38e3f5ab";
const injectCss = () => {
  var css = `.YW7BY{height:100%;position:absolute;top:0;width:100%;z-index:0}[dir] .YW7BY{border:0}[dir=ltr] .YW7BY{left:0}[dir=rtl] .YW7BY{right:0}.EG5Wk{bottom:0;position:absolute;top:0;z-index:3}[dir=ltr] .EG5Wk,[dir=rtl] .EG5Wk{left:0;right:0}.N4FM8{height:0;position:relative}[dir] .N4FM8{padding-bottom:56.25%}@supports not (contain:inline-size){@media only screen and (max-width:640px){.N4FM8{min-width:auto}}}@container (width < 640px){.N4FM8{min-width:auto}}.xvdum{bottom:0;height:100%;position:absolute;top:0;width:100%;z-index:1}[dir] .xvdum{cursor:move}.xvdum~*>*{pointer-events:none}.uNT0Q{height:0;overflow:hidden;visibility:hidden;width:0}.iuf9V,.uNT0Q{position:absolute}.iuf9V{align-items:center;color:#fff;display:flex;font-size:20px;font-weight:400;height:100%;justify-content:center;top:0;width:100%;z-index:1}[dir] .iuf9V{background:rgba(0,0,0,.5);text-align:center}[dir=ltr] .iuf9V{right:0}[dir=rtl] .iuf9V{left:0}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var default_video_styles_default = {
  "video_player": "YW7BY",
  "videoOverlay": "EG5Wk",
  "video_container": "N4FM8",
  "video_overlay": "xvdum",
  "hide_duration": "uNT0Q",
  "error": "iuf9V"
};
export {
  default_video_styles_default as default,
  injectCss
};
//# sourceMappingURL=default-video-styles-scss.js.map
